import { injectable } from '@wix/typesafe-inversify';
import type { PresetEditorPresence } from '@wix/ambassador-devcenter-v1-component/types';
import type { BlocksAppData } from '@wix/document-services-types';
import type { IBobWidgetImages } from './IBobWidgetImages';
import { generateWidgetThumbnail } from '@wix/blocks-widget-services/editor';
import { sdk as imagesSdk } from '@wix/image-kit';

@injectable()
export class BobWidgetImages implements IBobWidgetImages {
  getWidgetPresetsThumbnails(
    appData: BlocksAppData,
    widgetId: string,
    presetId: string,
    name: string,
    width: number,
    height: number,
    presetEditorPresence?: PresetEditorPresence,
  ) {
    const presetIdWithoutHash = presetId.replace('#', '');
    const wixMediaThumbnail = presetEditorPresence?.wixMediaThumbnail;

    const widgetThumb = wixMediaThumbnail
      ? imagesSdk.getScaleToFitImageURL(
          wixMediaThumbnail.url!,
          wixMediaThumbnail.width!,
          wixMediaThumbnail.height!,
          width,
          height,
        )
      : generateWidgetThumbnail({
          appDefinitionId: appData.appDefinitionId,
          baseUrls: appData.appFields?.platform?.baseUrls || {},
          widgetId,
          presetId: presetIdWithoutHash,
          size: {
            width,
            height,
          },
        });
    return {
      id: presetIdWithoutHash,
      src: widgetThumb,
      name,
    };
  }
}
